import * as React from "react";
import { BaseBlock, BaseBlockOptions, broadcastBlockLoad } from "sb-resp-lib";

import { BaseDict } from "./dict";
import { config } from "./config";
import { RacingCurrentEvents } from "./RacingCurrentEvents";
import { RacingCurrentEventsData } from "./data";

/*
    This structure allows us to use mocks during dev
    but not to include them when we do build:release
*/
import * as MOCKSTYPE from "sb-resp-lib/lib/mocks";
import * as LOCALMOCKS from "../../mocks";
let _: typeof MOCKSTYPE;
let _localMocks: typeof LOCALMOCKS;
let PageMethodsMock;
let RacingPageMethodsMock;
if (process.env.NODE_ENV === "development") {
    _ = require("sb-resp-lib/lib/mocks");
    _localMocks = require("../../mocks");
    PageMethodsMock = _.PageMethodsMock;
    RacingPageMethodsMock = _localMocks.RacingPageMethodsMock;
}

export class RacingCurrentEventsRoot extends BaseBlock {
    dataProvider!: RacingCurrentEventsData;
    options!: BaseBlockOptions;

    // constructor sets defaults
    constructor(
        domId: string,
        options: BaseBlockOptions = {
            dict: BaseDict,
            cms: {},
            navHandler: {},
            dataProvider: {},
        },racingGameBlockNavigation: Function
    ) {
        super(domId, options);

        if (process.env.NODE_ENV === "development") {

            // setup data mocks for debug build
            this.dataProvider = new RacingCurrentEventsData({
                pageMethods: new PageMethodsMock(),
                racingPageMethods: new RacingPageMethodsMock()
            },() => {})

            // setup dictionary for debug build
            this.options.dict = BaseDict;

            //export data store to window for debug purposes
            window["RacingCurrentEventsDATA"] = this.dataProvider;
        }

        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {

            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new RacingCurrentEventsData(options.dataProvider,racingGameBlockNavigation);
        }

        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = {...BaseDict, ...(options.dict || {})};

        // merge default and CMS options
        this.options.cms = {...config, ...(options.cms || {})};
    }

    activate() {
        return super.activate(
            <RacingCurrentEvents dataProvider={this.dataProvider} dict={this.options.dict} />
        );
    }
}

window["RacingCurrentEvents"] = RacingCurrentEventsRoot;
broadcastBlockLoad("RacingCurrentEvents");